import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const CityField = () => {
    const value = useWizardDemoStore((state) => state.property.city);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <TextBox
            id='propertyCity'
            value={value}
            onChange={(city) => updateProperty({ city })}
            label='City'
            required={true}
            width={'100%'}
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            height='36px'
        />
    );
};
